import Axios from "axios";
import { SET_DAYS_LIST, UNSET_DAYS_LIST } from "@/store/mutation-types";
import { getDaysList } from "@/store/api";
// initial state
const state = {
    getDaysList: [],
};

const getters = {
    getDaysList(state) {
        return state.getDaysList;
    },
};

const mutations = {
    [SET_DAYS_LIST](state, data) {
        state.getDaysList = data;
    },
    [UNSET_DAYS_LIST](state) {
        state.getDaysList = [];
    },
};

const actions = {
    getDaysList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getDaysList, data)
                .then(function (response) {
                    commit("SET_DAYS_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_DAYS_LIST");
                    reject(error);
                })
                .then((always) => { });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};